import React from 'react';
import {Route, Routes} from "react-router-dom";
import GroupsList from "./GroupsList/GroupsList";
import GroupForm from "./GroupForm/GroupForm";
import GroupDetails from "./GroupDetails/GroupDetails";
import NotFound from "../404/NotFound";

const MicroqualificationGroupsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<GroupsList/>}/>
            <Route path="/create" element={<GroupForm isEdit={false}/>}/>
            <Route path="/:groupId" element={<GroupDetails/>}/>
            <Route path="/:groupId/edit" element={<GroupForm isEdit={true}/>}/>
            <Route path="/*" element={<NotFound/>}/>
        </Routes>
    );
};

export default MicroqualificationGroupsRoutes;
